import {
    postPrivacyPolicyRepo, getPrivacyPolicyRepo
} from "../repositories/statisPages"
import { createSlice } from "@reduxjs/toolkit";

const staticPagesSlice = createSlice({
    name: "staticPagesReducer",
    initialState: {
        privacyPolicyDataLoading: false,
        privacyPolicyData: null,
        privacyPolicyDataError: null,

        postPrivacyPolicyLoading: false,
        postPrivacyPolicyData: null,
        postPrivacyPolicyError: null,
    },
    reducers: {

        getPrivacyPolicyLoading(state, action) {
            return {
                ...state,
                privacyPolicyDataLoading: true,
            };
        },
        getPrivacyPolicySuccess(state, action) {
            return {
                ...state,
                privacyPolicyDataLoading: false,
                privacyPolicyData: action.payload,
            };
        },
        getPrivacyPolicyFailure(state, action) {
            return {
                ...state,
                privacyPolicyDataLoading: false,
                privacyPolicyDataError: action.payload,
            };
        },

        clearGetPrivacyPolicyReponse(state, action) {
            return {
                ...state,
                privacyPolicyData: null,
                privacyPolicyDataError: null,
            };
        },

        postPrivacyPolicySuccess(state, action) {
            return {
                ...state,
                postPrivacyPolicyLoading: false,
                postPrivacyPolicyData: action.payload,
            };
        },
        postPrivacyPolicyFailure(state, action) {
            return {
                ...state,
                postPrivacyPolicyLoading: false,
                postPrivacyPolicyError: action.payload,
            };
        },
        clearPostPrivacyPolicyResponse(state, action) {
            return {
                ...state,
                postPrivacyPolicyData: null,
                postPrivacyPolicyError: null
            }
        },
    },
});
export const {
    getPrivacyPolicyLoading,
    getPrivacyPolicySuccess,
    getPrivacyPolicyFailure,
    clearGetPrivacyPolicyReponse,

    postPrivacyPolicySuccess,
    postPrivacyPolicyFailure,
    clearPostPrivacyPolicyResponse

} = staticPagesSlice.actions;

export const getPrivacyPolicy = (params) => {
    return async (dispatch) => {
        dispatch(getPrivacyPolicyLoading());
        await getPrivacyPolicyRepo(params)
            .then((response) => {
                if (response?.status == 200) {
                    dispatch(getPrivacyPolicySuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(getPrivacyPolicyFailure(error.message));
                }
            });
    };
};

export const postPrivacyPolicy = (params) => {
    return async (dispatch) => {
        await postPrivacyPolicyRepo(params)
            .then((response) => {
                if (
                    response?.status == 200 ||
                    response?.status == 201 ||
                    response?.status == 301
                ) {
                    dispatch(postPrivacyPolicySuccess(response?.data));
                }
            })
            .catch((error) => {
                if (error && error.response) {
                    dispatch(postPrivacyPolicyFailure(error.message));
                }
            });
    };
};
export default staticPagesSlice.reducer;